/*eslint max-lines-per-function: ["error", 450]*/
/* eslint-disable complexity */
import React, { useEffect, useState } from 'react';
import {
  Alert,
  Dropdown,
  DropdownButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useNavigation } from '../../../common/navigation';
import { GetExamDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import {
  ArticleMode,
  CardType,
  ConsultationType,
} from '../../../common/spdCore/validation/schemas';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

export const ExamEndLink = (props: {
  onExamChanged: (
    exam: Pick<GetExamDto, 'id' | 'endDate' | 'startDate'>,
  ) => Promise<void> | void;
  examId: string;
  endDate?: Date | null;
  startDate?: Date | null;
  mode?: ArticleMode | null;
}) => {
  const nav = useNavigation();
  const spd = useSpdCore();

  const [consultationsLabel, setConsultationsLabel] = useState<
    number | undefined
  >();
  const [cardsLabel, setCardsLabel] = useState<number | undefined>();
  const [isEndingExam, setIsEndingExam] = useState(false);
  const [judgmentsLabel, setJudgmentsLabel] = useState<number | undefined>();

  const [cardsDriverLabel, setCardsDriverLabel] = useState<
    number | undefined
  >();
  const [cardsPreventiveLabel, setCardsPreventiveLabel] = useState<
    number | undefined
  >();
  const [cardsSanitaryLabel, setCardsSanitaryLabel] = useState<
    number | undefined
  >();
  const [cardsPsychologistLabel, setCardsPsychologistLabel] = useState<
    number | undefined
  >();
  const [cardsPsychologistWeaponLabel, setCardsPsychologistWeaponLabel] =
    useState<number | undefined>();
  const [cardsWeaponLabel, setCardsWeaponLabel] = useState<
    number | undefined
  >();
  const [cardsSportLabel, setCardsSportLabel] = useState<number | undefined>();

  const [judgmentsPsychologistLabel, setJudgmentsPsychologistLabel] = useState<
    number | undefined
  >();
  const [judgmentsDoctorLabel, setJudgmentsDoctorLabel] = useState<
    number | undefined
  >();

  const [consultationNeurologistName, setConsultationNeurologistName] =
    useState<number | undefined>();
  const [consultationOphthalmologistName, setConsultationOphthalmologistName] =
    useState<number | undefined>();
  const [consultationENTName, setConsultationENTName] = useState<
    number | undefined
  >();
  const [consultationPsychiatricName, setConsultationPsychiatricName] =
    useState<number | undefined>();

  useEffect(() => {
    if (props.examId) {
      let pomLabel = 0;

      spd.cards
        .getAllByExam(props.examId)
        .then(o => {
          let cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Driver,
          ).length;
          setCardsDriverLabel(cardCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Preventive,
          ).length;
          setCardsPreventiveLabel(cardCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Sanitary,
          ).length;
          setCardsSanitaryLabel(cardCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Psychologist,
          ).length;
          setCardsPsychologistLabel(cardCount);
          if (!props.mode || props.mode === ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t =>
              (t.type as unknown as CardType) === CardType.PsychologistWeapon,
          ).length;
          setCardsPsychologistWeaponLabel(cardCount);
          if (!props.mode || props.mode === ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Weapon,
          ).length;
          setCardsWeaponLabel(cardCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }
          cardCount = o.filter(
            t => (t.type as unknown as CardType) === CardType.Sport,
          ).length;
          setCardsSportLabel(cardCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + cardCount;
          }

          setCardsLabel(pomLabel);
        })
        .catch(error => console.log(error, 'Nie udało się pobrać liczby kart'));
    }
  }, [spd.cards, props.examId, props.mode]);

  useEffect(() => {
    if (props.examId && props.mode !== ArticleMode.Ophthalmologist) {
      let pomLabel = 0;
      spd.judgments
        .getForExam(props.examId)
        .then(o => {
          const judPsychoCount = o.filter(
            j =>
              (j?.article?.mode as unknown as ArticleMode) ===
              ArticleMode.Psychologist,
          ).length;
          const judDoctorCount = o.length - judPsychoCount;
          setJudgmentsPsychologistLabel(judPsychoCount);
          setJudgmentsDoctorLabel(judDoctorCount);
          if (props.mode !== ArticleMode.Psychologist) {
            pomLabel = pomLabel + judDoctorCount;
          }
          if (props.mode !== ArticleMode.Doctor) {
            pomLabel = pomLabel + judPsychoCount;
          }
          setJudgmentsLabel(pomLabel);
        })
        .catch(() => console.log('Nie udało się pobrać orzeczeń'));
    }
  }, [spd.judgments, props.examId, props.mode]);

  useEffect(() => {
    if (props.examId && props.mode !== ArticleMode.Psychologist) {
      let pomLabel = 0;
      spd.consultations
        .getForExam(props.examId)
        .then(o => {
          const consNeuroCount = o.filter(
            j =>
              (j?.type as unknown as ConsultationType) ===
              ConsultationType.Neurological,
          ).length;
          if (
            !props.mode ||
            props.mode === ArticleMode.Doctor ||
            props.mode === ArticleMode.Neurologist
          ) {
            pomLabel = pomLabel + consNeuroCount;
          }
          const consOphtalCount = o.filter(
            j =>
              (j?.type as unknown as ConsultationType) ===
              ConsultationType.Ophthalmologist,
          ).length;
          if (
            !props.mode ||
            props.mode === ArticleMode.Doctor ||
            props.mode === ArticleMode.Ophthalmologist
          ) {
            pomLabel = pomLabel + consOphtalCount;
          }
          const consENTCount = o.filter(
            j =>
              (j?.type as unknown as ConsultationType) === ConsultationType.ENT,
          ).length;
          if (
            !props.mode ||
            props.mode === ArticleMode.Doctor ||
            props.mode === ArticleMode.Laryngologist
          ) {
            pomLabel = pomLabel + consENTCount;
          }
          const consPsychiatricCount = o.filter(
            j =>
              (j?.type as unknown as ConsultationType) ===
              ConsultationType.Psychiatric,
          ).length;
          if (
            !props.mode ||
            props.mode === ArticleMode.Doctor ||
            props.mode === ArticleMode.Psychiatrist
          ) {
            pomLabel = pomLabel + consPsychiatricCount;
          }
          setConsultationNeurologistName(consNeuroCount);
          setConsultationOphthalmologistName(consOphtalCount);
          setConsultationENTName(consENTCount);
          setConsultationPsychiatricName(consPsychiatricCount);
          setConsultationsLabel(pomLabel);
        })
        .catch(() => console.log('Nie udało się pobrać konsultacji'));
    }
  }, [spd.consultations, props.examId, props.mode]);

  const endExam = async () => {
    if (props.examId) {
      setIsEndingExam(true);
      try {
        await props.onExamChanged({
          id: props.examId,
          endDate: new Date(),
          startDate: !props.startDate ? new Date() : props.startDate,
        });
      } finally {
        setIsEndingExam(false);
      }
    }
  };

  const getTextButton = (text: string, count: number | undefined) => {
    return `${text} ${count ? `(${count})` : ''}`;
  };

  return (
    <>
      {props.examId && props.endDate && (
        <div style={{ display: 'flex' }}>
          <DropdownButton
            title={getTextButton('Karty', cardsLabel)}
            id="cards-dropdown"
            variant="outline-primary"
            className="ms-1 mb-1"
          >
            {(!props.mode || props.mode === ArticleMode.Psychologist) && (
              <>
                <Dropdown.Item
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsPsychologic(props.examId);
                  }}
                  eventKey="1"
                >
                  {getTextButton(
                    'Karta psychologiczna',
                    cardsPsychologistLabel,
                  )}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsPsychologicWeapon(props.examId);
                  }}
                  eventKey="1"
                >
                  {getTextButton(
                    'Karta psychologiczna na broń',
                    cardsPsychologistWeaponLabel,
                  )}
                </Dropdown.Item>
              </>
            )}
            {props.mode !== ArticleMode.Psychologist && (
              <>
                <Dropdown.Item
                  eventKey="2"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsPreventive(props.examId);
                  }}
                >
                  {getTextButton('Karta profilaktyczna', cardsPreventiveLabel)}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="3"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsDriver(props.examId);
                  }}
                >
                  {getTextButton('Karta kierowcy', cardsDriverLabel)}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="4"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsSanitary(props.examId);
                  }}
                >
                  {getTextButton(
                    'Karta sanitarno-epidemiologiczna',
                    cardsSanitaryLabel,
                  )}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="4"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsSport(props.examId);
                  }}
                >
                  {getTextButton('Karta sportowa', cardsSportLabel)}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examCardsWeapon(props.examId);
                  }}
                  eventKey="1"
                >
                  {getTextButton('Karta broń', cardsWeaponLabel)}
                </Dropdown.Item>
              </>
            )}
          </DropdownButton>
          {
            <DropdownButton
              title={getTextButton('Orzeczenia', judgmentsLabel)}
              id="judgments-dropdown"
              variant="outline-primary"
              className="ms-1 mb-1"
            >
              {(!props.mode || props.mode === ArticleMode.Psychologist) && (
                <Dropdown.Item
                  eventKey="1"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examPsychologistJudgments(props.examId);
                  }}
                >
                  {getTextButton(
                    'Orzeczenia psychologiczne',
                    judgmentsPsychologistLabel,
                  )}
                </Dropdown.Item>
              )}
              {props.mode !== ArticleMode.Psychologist && (
                <Dropdown.Item
                  eventKey="2"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.examDoctorJudgments(props.examId);
                  }}
                >
                  {getTextButton('Orzeczenia lekarskie', judgmentsDoctorLabel)}
                </Dropdown.Item>
              )}
            </DropdownButton>
          }
          {props.mode !== ArticleMode.Psychologist && (
            <DropdownButton
              title={getTextButton('Konsultacje', consultationsLabel)}
              id="consultations-dropdown"
              variant="outline-primary"
              className="ms-1 mb-1"
            >
              {(!props.mode || props.mode === ArticleMode.Neurologist) && (
                <Dropdown.Item
                  eventKey="1"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.consultationNeurological(props.examId);
                  }}
                >
                  {getTextButton(
                    'Konsultacja neurologiczna',
                    consultationNeurologistName,
                  )}
                </Dropdown.Item>
              )}
              {(!props.mode || props.mode === ArticleMode.Ophthalmologist) && (
                <Dropdown.Item
                  eventKey="2"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.consultationOphthalmologist(props.examId);
                  }}
                >
                  {getTextButton(
                    'Konsultacja okulistyczna',
                    consultationOphthalmologistName,
                  )}
                </Dropdown.Item>
              )}
              {(!props.mode || props.mode === ArticleMode.Laryngologist) && (
                <Dropdown.Item
                  eventKey="3"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.consultationENT(props.examId);
                  }}
                >
                  {getTextButton(
                    'Konsultacja laryngologiczna',
                    consultationENTName,
                  )}
                </Dropdown.Item>
              )}
              {(!props.mode || props.mode === ArticleMode.Psychiatrist) && (
                <Dropdown.Item
                  eventKey="3"
                  onClick={e => {
                    e.stopPropagation();
                    void nav.consultationPsychiatric(props.examId);
                  }}
                >
                  {getTextButton(
                    'Konsultacja psychiatryczna',
                    consultationPsychiatricName,
                  )}
                </Dropdown.Item>
              )}
            </DropdownButton>
          )}
        </div>
      )}

      {props.examId &&
        !props.endDate &&
        (!props.mode ||
          props.mode === ArticleMode.Psychiatrist ||
          props.mode === ArticleMode.Doctor) && (
          <OverlayTrigger overlay={<Tooltip>Zakończenie badania</Tooltip>}>
            <ConfirmationButton
              confirmation="Czy na pewno zakończyć badanie? Badany nie będzie mógł uruchomić badania ponownie."
              variant="outline-danger"
              onOK={() => endExam()}
              isLoading={isEndingExam}
              disabled={isEndingExam}
            >
              Zakończ badanie
            </ConfirmationButton>
          </OverlayTrigger>
        )}
      {props.examId &&
        !props.endDate &&
        props.mode &&
        props.mode !== ArticleMode.Psychiatrist &&
        props.mode !== ArticleMode.Doctor && (
          <Alert variant={'warning'}>
            Dostęp do menu konsultacji/orzeczeń/kart będzie możliwy, jak badany
            zakończy badanie
          </Alert>
        )}
    </>
  );
};
